import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { TopMenuTemplateService } from '../../services/top-menu-template.service';
import { Store } from '@ngrx/store';
import { selectUnidadeLista } from 'src/app/store/unidade/unidade.selectors';
import { loadUnidade } from 'src/app/store/unidade/unidade.actions';
import { UnidadeService } from '../../services/unidade.service';
import { map } from 'rxjs';
import { ChooseUnitModalComponent } from 'src/app/core/components/choose-unit-modal/choose-unit-modal.component';
import { ModalService } from '../../services/modal.service';
import { DialogService } from 'primeng/dynamicdialog';
import { HelpFormComponent } from '../help-form/help-form.component';
import { UserService } from '../../services/user.service';
import { IUnidade } from '../../interfaces/unidade/iunidade'

@Component({
  selector: 'app-menu-topo',
  templateUrl: './menu-topo.component.html',
  styleUrls: ['./menu-topo.component.scss']
})
export class MenuTopoComponent implements OnInit {
  SelectedUnit: any
  SelectedUnitName: any = '';
  units$ = this.store.select(selectUnidadeLista).pipe(map((lista: any[]) => lista.filter(item => item.isActive)))
  name: string = ''
  userId = localStorage.getItem('userId')
  allowedUnits: any[] = []
  unitsByUser = [];
  @Input() isShowMenu: boolean = false
  @Output() isShowMenuChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private router: Router,
    private store: Store,
    private authenticationService: AuthenticationService,
    private unidadeService: UnidadeService,
    public topMenuTemplateService: TopMenuTemplateService,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private modalService: ModalService,
    private userService: UserService
  ) { }
  ngOnInit(): void {
     this.store.dispatch(loadUnidade());

    this.userService.getbyID(Number(this.userId)).subscribe({
      next: (res: any) => { 
        this.unitsByUser = res.units.filter( (u: any) => u.isActive == true)
      },
      error: (err: any) => { console.log('ocorreu um erro: ', err) }
    })
    this.name = this.authenticationService.decodedToken().given_name;
    this.unidadeService.getById(Number(<string>localStorage.getItem('unitId')))
      .subscribe((unit: any) => {
        this.SelectedUnit = unit.id;
        this.SelectedUnitName = unit.unitName;
        localStorage.setItem('unitName', unit.unitName);
      })
  }

  ngAfterViewInit() {
      let user = this.authenticationService.decodedToken();
      //this.loadWidget();
  }

  ngOnDestroy(){
    this.removeWidget();
  }

  unitChange(item: any) {
    console.log(item)
    localStorage.setItem('unitId', item.value);
    setTimeout(() => { window.location.reload(); }, 100)
  }

  logout() {
    this.authenticationService.logOut();
    this.router.navigate(['login']);
  }

  openExternalUrl(url: string) {
    window.open(url, '_blank');
  }

  openUnitModal() {
    this.dialogService.open(ChooseUnitModalComponent, {
      header: `Selecionar Unidade`,
      width: '70%',
      style: {
        'height': 'auto',
        'max-height': '98vh'
      },
      baseZIndex: 10000,
      dismissableMask: false,
      styleClass: 'dialogComponent',
      closable: false
    });
  }

  openFormModal() {
    this.modalService.show(HelpFormComponent, '', undefined, 'dynamicModalForm')
  }

  setAllowedUnits(units: IUnidade[]) {
    //console.log(units);
   
    
    this.units$.subscribe({
      next: (res) => {
        if(!res || res.length == 0){
          return
        }
        this.allowedUnits = []
        units.forEach( unitIriReference => {
          //console.log(res)
          let unit = res.find(resUnit => resUnit['@id'] == unitIriReference)
          //console.log(unit)
          this.allowedUnits.push(unit)
        })
      }
    })
  }

  showMenu() {
    console.log("showMenu")
    this.isShowMenu = true;
    this.isShowMenuChange.emit(true);
  }

   loadWidget(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://splitpaysplitpagamentos.lovable.app/widget-suporte.js';
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject();

      document.body.appendChild(script);
    });
  }

  removeWidget(): void {
    const scripts = document.querySelectorAll(`script[src="https://splitpaysplitpagamentos.lovable.app/widget-suporte.js"]`);
    const widget = document.querySelector('#splitpay-support-widget');
    scripts.forEach(script => {
      script.parentNode?.removeChild(script);
    });
    if (widget) {
      widget.parentNode?.removeChild(widget);
    } 
  }

}
